import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import sectorReducer from './sectorSlice';
import FilterReducer from './filterSlice'
import workspaceReducer from'./workspaceSlice'
import LocationTireReducer from './locationSlice'
import mapConfigReducer from './mapConfigSlice'
import visualizationTypeReducer from './visualizationTypeSlice'
import mapconfigApiSlice from './mapConfigApi'
import ulgMapConfigReducer from './ulgmapconfigslice'
import checkboxSlice from './checkboxindicatorSlice'
import selectedTagReducer from './selectedTagSlice';

// Persist configuration for workspace state only
const workspacePersistConfig = {
  key: 'workspace',
  storage,
  whitelist: [
    'selectedIndicators',
    'selectedMapFeatures', 
    'isWorkspaceLoaded',
    'loadedWorkspaceName',
    'currentWorkspace',
    'workspaceId',
    'hasUnsavedChanges',
    'originalWorkspaceData'
  ]
};

const rootReducer = combineReducers({
  sector: sectorReducer,
  filter: FilterReducer,
  workspace: persistReducer(workspacePersistConfig, workspaceReducer),
  locationTire: LocationTireReducer,
  mapConfig: mapConfigReducer,
  visualizationType: visualizationTypeReducer,
  mapApiConfig: mapconfigApiSlice,
  checkboxSlice: checkboxSlice,
  selectedTag: selectedTagReducer,
  ulgMapConfig: ulgMapConfigReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;